import { ReactElement, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDependency } from "../../../../contexts/DependencyContext";
import { useEventListener } from "../../../../hooks/UseEventListener";
import { LoginService } from "../../../../services/LoginService";
import { className } from "../../../../shared/helpers";
import styles from "./UserOptions.module.scss";

interface UserOptionsProps
{
    searchVisible: boolean;
    setSearchVisibility: (state: boolean) => void;
}

const UserOptions = (props: UserOptionsProps): ReactElement =>
{
    const loginService = useDependency(LoginService);
    const history = useHistory();
    const options = useRef<HTMLDivElement>(null as any);
    const [optionsVisible, setOptionsVisibility] = useState(false);

    function logout(): void
    {
        loginService.logout();
        history.push("/login");
    }

    function handleClickOutside(e: PointerEvent): void
    {
        const target = e.target as HTMLElement;

        if (!options.current.contains(target))
            setOptionsVisibility(false)
    }

    useEventListener("pointerdown", handleClickOutside);

    return (
        <div
            ref={options}
            {...className(
                styles.userOptions,
                { [styles.searchVisible]: props.searchVisible }
            )}
        >
            {props.searchVisible && (
                <button
                    key="close-search-btn"
                    className={styles.closeSearchBtn}
                    onClick={() => props.setSearchVisibility(!props.searchVisible)}
                >
                    <i className="material-icons">close</i>
                </button>
            )}

            <button
                key="user-options-btn"
                className={styles.userOptionsBtn}
                onClick={() => !props.searchVisible && setOptionsVisibility(!optionsVisible)}
            >
                <i className="material-icons">person</i>
            </button>

            {optionsVisible && (
                <ul className={styles.dropdown}>
                    <li><button onClick={logout}>Logout</button></li>
                </ul>
            )}
        </div>
    );
};

export default UserOptions;
